import { render, staticRenderFns } from "./Behaviors.vue?vue&type=template&id=19a96f6b&scoped=true&"
import script from "./Behaviors.vue?vue&type=script&lang=js&"
export * from "./Behaviors.vue?vue&type=script&lang=js&"
import style0 from "./Behaviors.vue?vue&type=style&index=0&id=19a96f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a96f6b",
  null
  
)

export default component.exports